export default __webpack_public_path__ + "static/media/Version (7) - Snape Insult_00.fe9d6f5b.jpg";